import classNames from 'classnames';
import SliderModule from 'react-slick';
import Image from 'next/image';

import { Button } from '@/ui/index';
import { Arrow, SliderDotIndicator } from '@/icons/index';

import styles from './styles.module.scss';

const Slider = ({ data, black = false }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    focusOnSelect: false,
    pauseOnHover: false,
    draggable: true,
    autoplaySpeed: 5000,
    appendDots: (dots) => (
      <div>
        <ul className={`${styles.dots} wrapper`}>{dots}</ul>
      </div>
    ),
    customPaging: () => (
      <div className={styles.dot}>
        <SliderDotIndicator />
      </div>
    ),
  };

  const renderSlid = (item, index) => {
    return (
      <div
        className={classNames([styles.item, { [styles.black]: black }])}
        key={index}
        itemScope
        itemType='https://schema.org/CreativeWork'
      >
        <div className={`wrapper ${styles.content}`}>
          {item?.heading_text && (
            <h3
              className={styles.text}
              dangerouslySetInnerHTML={{ __html: item?.heading_text }}
            />
          )}
          {item?.title && (
            <h3
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: item?.title }}
            />
          )}
          {item?.button_text && (
            <Button
              className={styles.button}
              Component={item?.button_slug ? 'router' : 'a'}
              href={item?.button_slug || item?.external_link}
            >
              {item?.button_text} <Arrow width={16} />
            </Button>
          )}
        </div>
        {item?.image && (
          <div className={styles.imgWrapper}>
            <Image
              src={item?.image}
              alt={item?.title}
              title={item?.title}
              width={800}
              height={640}
              className={styles.img}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      className={styles.slider}
      itemScope
      itemType='https://schema.org/ItemList'
    >
      <SliderModule {...settings}>{data?.items?.map(renderSlid)}</SliderModule>
    </div>
  );
};

export default Slider;
